import { commonApi } from './api';
import axios from './request';
import { getVueAppUploadApi } from './util';
import { getCompanyInfo } from '@/utils/getCompanyInfo';

/**
 * 上传字体文件
 */
export const uploadFont = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('companyId', getCompanyInfo()?.id?.toString() || '');
  return axios.post(`${getVueAppUploadApi()}/upload/cartseeUploadFont`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 保存字体信息
 */
export const saveFont = (params: {
  fileName: string;
  url: string;
  fontName: string;
  defaultFont: string;
}) => {
  return commonApi(params, 'cartsee.formFont.save');
};

/**
 * 获取公司字体列表
 */
export const getCompanyFontList = (params: any = {}) => {
  return commonApi(params, 'cartsee.formFont.list');
}